import React from 'react'

export const PDFIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M15 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H19C20.1 22 21 21.1 21 20V8L15 2Z"
        fill="#E4E5E6"
      />
      <path d="M14.9805 2V8.02H21.0005" fill="#C9C9C9" />
      <path
        d="M15.72 10H3.28C2.57308 10 2 10.5731 2 11.28V18.72C2 19.4269 2.57308 20 3.28 20H15.72C16.4269 20 17 19.4269 17 18.72V11.28C17 10.5731 16.4269 10 15.72 10Z"
        fill="#F22C00"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 12C6.55 12 7 12.45 7 13V14.5C7 15.04 6.57002 15.47 6.04004 15.5H5V18H4V12H6ZM5 14.5H6V13H5V14.5Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 12C10.55 12 11 12.45 11 13V17C11 17.55 10.55 18 10 18H8V12H10ZM9 13V17H10V13H9Z"
        fill="white"
      />
      <path d="M15 13H13V14.5H14V15.5H13V18H12V12H15V13Z" fill="white" />
    </svg>
  )
}
